import { Toaster } from 'react-hot-toast';
import AppRoutes from './routes/AppRoutes';
import AOS from "aos"

import "aos/dist/aos.css";
import { useEffect } from 'react';
import ScrollToTop from './routes/ScrollToTop';
import GoogleTagManager from '@/components/analytics/GoogleTagManager';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
      <ScrollToTop />
      <GoogleTagManager />


      <AppRoutes />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#111827',
            color: '#ffffff',
            borderLeft: '4px solid #22d3ee',
            padding: '16px',
            fontWeight: 500,
          },
          success: {
            iconTheme: { primary: '#22d3ee', secondary: '#111827' },
          },
          error: {
            iconTheme: { primary: '#ef4444', secondary: '#111827' },
          },
        }}
      />
    </>
  );
}

export default App;